// France
export const locale = {
    GLOBAL :{
        Title : "پیامک لند",
        PostalCode : "کد پستی",
        postalCodes : "کد های پستی",
        selectedPostalCodes : "کد های پستی انتخاب شده",
        MciNumberCount : "تعداد همراه اول",
        MtuNumberCount : "تعداد ایرانسل",
        TotalCount : "تعداد کل",
        Coefficient : "ضریب",
        Back : "بازگشت"
    },
    ERRORS:{
        PhoneIsNotValid : "شماره تلفن وارد شده صحیح نمیباشد: نمونه 09101234567",
        InvalidNumber : "تعداد وارد شده صحیح نمیباشد",
        NoSelectedLineNumber : "خط ارسالی را انتخاب کنید.",
        EmptyText : "لطفا متن را وارد کنید.",
        UnknownError : "خطای نامشخص",
        TryAgain : "لطفا کمی بعد دباره تلاش کنید.",
        NoAccountCharge : "موجودی ناکافی",
        NoAccess : "دسترسی ندارید.",
        PleasebyeAPlane : "لطفا یک پلن خریداری کنید.",
        PleaseChargeYourAccount : "لطفا اکانت خود را شارژ کنید.",
        AccessDenied: "دسترسی ندارید.",
        AccessDeniedDescription : "برای اطلاعات بیشتر با پشتیبانی تماس بگیرید",
        Error : "خطا",
        InvalidText : "متن نامعتبر",
        InvalidTextContainsLink : "تنها خطوط خدماتی میتوانند حاوی لینک باشند."
    },
    INFOS : {
        SuccessSentSms : "پیام ارسال شد",
        SmsRequestInQueue : "پیام شما بعد از تایید مدیر ارسال خواهد شد",
        SendData : "اطلاعات ارسال",
        CheckData : "اطلاعات زیر را بخوانید و تایید کنید."
    },
    TOBE:{
        to:"به ",
        from:"از ",
    },
    FORMS:{
        DestinationPhone : "شماره تلفن گیرنده",
        TestDestinationPhone : "شماره تلفن تست",
        SourceNumber : "شماره فرستده",
        Text : "متن",
        CharCount : "تعداد کاراکترها",
        FarsiCharCount: "تعداد کاراکترهای فارسی",
        EnglishCharCount : "تعداد کاراکتر های انگلیسی",
        Send : "ارسال",
        SendTime : "زمان ارسال",
        SendTest : "ارسال تستی",
        SendToTestNumber : "ارسال به شماره تست",
        SmsCount : "تعداد پیامک",
        SmsLang : "زبان پیامک",
        Add:"اضافه کردن",
        FromFile : "افزودن فایل",
        TestNumber: "شماره تست",
        Test : "تست",
        ServiceRelated : "خدماتی",
        Price : "قیمت",
        NumbersCount : "تعداد شماره ها",
        NumbersCountToSend : "تعدا شماره هایی که به آنها پیام ارسال میشود",
        Search : "جستجو",
        Title : "عنوان",
        RequestTime : "زمان درخواست",
        RequestInformation : "اطلاعات درخواست" ,
        CreateNewPhoneBook: "ساخت دفترچه تلفن جدید"
    },
    BUTTONS:{
        OK : "باشه",
        AccountCharge : "شارژ حساب",
        Reports: "گزارش ها",
        RemoveAll : "حذف همه",
        BuyAPlane: "خرید پلن",
        Accept : "تایید",
        Reject : "رد کردن",
        Yes : "بله",
        No : "خیر",
        Create : "ایجاد",
        New : "جدید",
        Save : "ذخیره",
        Delete:"حذف",
        More : "بیشتر",
        TryAgain : "تلاش مجدد",
        Close : "بستن"
    },
    DIALOGS:{
        Waiting: "لطفا صبر کنید",
        RejectItQuestion: "رد شود؟",
        AcceptItQuestion: "تایید شود؟",
        Rejected: "رد شد",
        Accepted: "تایید شد",
        Error: "خطا",
    },
    CONFIRM:{
        Delete : "آیا از حذف مطمعین هستید؟",
        DeleteA : "ایا مطمعین از حذف {a} هستید",
        DeleteALL : "آیا از حذف همه مطمعین هستید؟"
    },
    LANGUAGE:{
        English : "انگلیسی",
        Persian : "فارسی"
    },
    LISTS: {
        NoData : "داده ای وجود ندارد",
        NoDataFound : "داده ای پیدا نشد",
        NoDataFoundFor : "داده ای برای {a} پیدا نشد",
        NoPhoneNumber : "شماره ای پیدا نشد",
        NoPostalCode : "کد پستی ای پیدا نشد",
        AddANumber : "شماره ای اضافه کنید",
        City : "شهر",
        AddedBefore : "قبلا اضافه شده است"
    },
    PAGES: {
        SendSms : "ارسال پیامک",
        MapSms : "ارسال با نقشه",
        PhoneBook : "دفترچه تلفن",
    },
    MONETARY :{
        Rial : "ریال"
    },
    HINTS:{
        SendMessageTitle : "عنوان نام دلخواهی است که میتوانید از عنوان پیام های قبلی ارسال شده استفاده کنید تا متن پیام در بخش متن نوشته شود. عنوان در پیام ارسال نمیشود. عنوان برای بخش گذارش گیری و پیشنهادات پیام استفاده میشود.",
        SendMessageTime : "زمان ارسال زمانی است که پیامک شما در صف ارسال قرار گرفته میشود. ت.جه داشته باشید که در صورت تایید نشدن توسط ادمین پیامک ارسال نمیشود.",
        CreatePhoneBook : "هنگام ارسال پیامک برای اضافه کردن شماره ازا این نام استفاده میشود."
    },
    TOASTS :{
        SuccessCreate : "با موقیت ایجاد شد",
        FailedCreated : "خطا در ایجاد کردن",
        SuccessDelete : "حذف شد",
        FailedDelete : "خطا در حذف",
        SuccessEdit : "ویرایش شد",
        FailedEdit : "خطا در ویرایش",
        AddedSuccess: "اضافه شد",
        AddedFailed: "خطا در اضافه کردن"
    },

    WALLET:{
        CustomCharge : "مبلغ دلخواه",
        GateWay : "درگاه پرداخت",
        Price : "مبلغ",
        Details : [
            "٩٪؜ ماليات به مبلغ وارد شده اضافه خواهد شد.",
            "لطفا در درج مبلغ دقت لازم را مبذول فرمایید، مبلغ واریزی به هیچ عنوان قابل استرداد نمی باشد."
        ],
        noGateWay : "درگاهی برای شما تعریف نشده است.",
        PriceNotInRange : "مبلغ ورودی باید بین {min} ریال و {max} ریال باشد.",
        Pay : "پرداخت",
        ErrorOnRedirectToGateWay : "خطا در انتقال به درگاه پرداخت",
        ChargeWalletButtonDescription : "بازدن روی دکمه + حساب خود را شارژ کنید",
    },

    TRANSLATOR: {
        SELECT: "choisissez votre langue"
    },
    MENU: {
        NEW: "Nouveau",
        ACTIONS: "Actes",
        CREATE_POST: "Créer un nouveau Post",
        PAGES: "Pages",
        FEATURES: "Fonctionnalités",
        APPS: "Applications",
        DASHBOARD: "Tableau de Bord"
    },
    AUTH: {
        GENERAL: {
            OR: "Ou",
            SUBMIT_BUTTON: "Soumettre",
            NO_ACCOUNT: "Ne pas avoir de compte?",
            SIGNUP_BUTTON: "Registre",
            FORGOT_BUTTON: "Mot de passe oublié",
            BACK_BUTTON: "Back",
            PRIVACY: "Privacy",
            LEGAL: "Legal",
            CONTACT: "Contact"
        },
        LOGIN: {
            TITLE: "Créer un compte",
            BUTTON: "Sign In"
        },
        FORGOT: {
            TITLE: "Forgot Password?",
            DESC: "Enter your email to reset your password",
            SUCCESS: "Your account has been successfully reset."
        },
        REGISTER: {
            TITLE: "Sign Up",
            DESC: "Enter your details to create your account",
            SUCCESS: "Your account has been successfuly registered."
        },
        INPUT: {
            EMAIL: "Email",
            FULLNAME: "Fullname",
            PASSWORD: "Mot de passe",
            CONFIRM_PASSWORD: "Confirm Password",
            USERNAME: "Nom d'utilisateur"
        },
        VALIDATION: {
            INVALID: "{{name}} n'est pas valide",
            REQUIRED: "{{name}} est requis",
            MIN_LENGTH: "{{name}} minimum length is {{min}}",
            AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
            NOT_FOUND: "The requested {{name}} is not found",
            INVALID_LOGIN: "The login detail is incorrect",
            REQUIRED_FIELD: "Required field",
            MIN_LENGTH_FIELD: "Minimum field length:",
            MAX_LENGTH_FIELD: "Maximum field length:",
            INVALID_FIELD: "Field is not valid"
        }
    },
    ECOMMERCE: {
        COMMON: {
            SELECTED_RECORDS_COUNT: "Nombre d'enregistrements sélectionnés: ",
            ALL: "All",
            SUSPENDED: "Suspended",
            ACTIVE: "Active",
            FILTER: "Filter",
            BY_STATUS: "by Status",
            BY_TYPE: "by Type",
            BUSINESS: "Business",
            INDIVIDUAL: "Individual",
            SEARCH: "Search",
            IN_ALL_FIELDS: "in all fields"
        },
        ECOMMERCE: "éCommerce",
        CUSTOMERS: {
            CUSTOMERS: "Les clients",
            CUSTOMERS_LIST: "Liste des clients",
            NEW_CUSTOMER: "Nouveau client",
            DELETE_CUSTOMER_SIMPLE: {
                TITLE: "Suppression du client",
                DESCRIPTION: "Êtes-vous sûr de supprimer définitivement ce client?",
                WAIT_DESCRIPTION: "Le client est en train de supprimer ...",
                MESSAGE: "Le client a été supprimé"
            },
            DELETE_CUSTOMER_MULTY: {
                TITLE: "Supprimer les clients",
                DESCRIPTION:
                    "Êtes-vous sûr de supprimer définitivement les clients sélectionnés?",
                WAIT_DESCRIPTION: "Les clients suppriment ...",
                MESSAGE: "Les clients sélectionnés ont été supprimés"
            },
            UPDATE_STATUS: {
                TITLE: "Le statut a été mis à jour pour les clients sélectionnés",
                MESSAGE:
                    "Le statut des clients sélectionnés a été mis à jour avec succès"
            },
            EDIT: {
                UPDATE_MESSAGE: "Le client a été mis à jour",
                ADD_MESSAGE: "Le client a été créé"
            }
        }
    }
};
